import { LAZADA_CALLBACK_PATH } from './static'

if (window.location.pathname === LAZADA_CALLBACK_PATH) {
  window.history.replaceState(null, '', `/#${LAZADA_CALLBACK_PATH}${window.location.search}`)
}
